var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsSolution6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6504 22.0484C17.6504 20.5356 18.5039 19.1522 19.856 18.4735L36.2041 10.2678C37.3333 9.7011 38.6638 9.7011 39.7929 10.2678L56.141 18.4735C57.4931 19.1522 58.3467 20.5356 58.3467 22.0484V33.8846C58.3467 40.6689 56.1991 47.2791 52.2117 52.7679V52.7679C51.2267 54.1239 50.137 55.4007 48.9528 56.5866L42.9518 62.5962C40.2174 65.3347 35.7797 65.3346 33.0452 62.5962L27.0443 56.5866C25.86 55.4007 24.7704 54.1239 23.7853 52.7679V52.7679C19.798 47.2791 17.6504 40.6689 17.6504 33.8846V22.0484Z",
    fill: "url(#paint0_linear_2137_19377)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.998 64.6096C39.7908 64.6099 41.5836 63.9258 42.951 62.5573L48.9543 56.5492C50.1381 55.3646 51.2273 54.0891 52.212 52.7344C56.1996 47.2488 58.3474 40.6413 58.3474 33.8595V22.0363C58.3474 20.5231 57.4935 19.1394 56.1409 18.4609L39.7927 10.2605C39.2281 9.97728 38.613 9.83575 37.998 9.83594V64.6096Z",
    fill: "url(#paint1_linear_2137_19377)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.987 27.2358C33.987 25.0786 35.7357 23.3299 37.8929 23.3299C40.0501 23.3299 41.7988 25.0786 41.7988 27.2358L41.7988 31.6152",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2065 33.5474C46.2065 32.4428 45.3111 31.5474 44.2065 31.5474H31.7891C30.6845 31.5474 29.7891 32.4428 29.7891 33.5474V45.9648C29.7891 47.0694 30.6845 47.9648 31.7891 47.9648H44.2065C45.3111 47.9648 46.2065 47.0694 46.2065 45.9648V33.5474ZM37.9994 42.3721C39.4442 42.3721 40.6155 41.2008 40.6155 39.7559C40.6155 38.3111 39.4442 37.1398 37.9994 37.1398C36.5545 37.1398 35.3832 38.3111 35.3832 39.7559C35.3832 41.2008 36.5545 42.3721 37.9994 42.3721Z",
    fill: "#FDFDFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8945 47.9648H44.1037C45.2082 47.9648 46.1037 47.0694 46.1037 45.9648V33.5474C46.1037 32.4428 45.2082 31.5474 44.1037 31.5474H37.8945V37.1398C37.8952 37.1398 37.8958 37.1398 37.8965 37.1398C39.3413 37.1398 40.5126 38.3111 40.5126 39.7559C40.5126 41.2008 39.3413 42.3721 37.8965 42.3721C37.8958 42.3721 37.8952 42.3721 37.8945 42.3721V47.9648Z",
    fill: "url(#paint2_linear_2137_19377)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19377",
    x1: 37.9985,
    y1: 15.0413,
    x2: 37.9985,
    y2: 67.5567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDAC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_19377",
    x1: 37.999,
    y1: 15.0299,
    x2: 37.999,
    y2: 75.4265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2137_19377",
    x1: 41.9991,
    y1: 31.5474,
    x2: 41.9991,
    y2: 47.9648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsSolution6);
export default __webpack_public_path__ + "static/media/awsSolution6.fbc8fcd463d8cb2694f43214f21c9a84.svg";
export { ForwardRef as ReactComponent };